import { render } from "./App.vue?vue&type=template&id=8d6ce30a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8d6ce30a&lang=css"
script.render = render

export default script